<template>
  <!--  主页-->
  <div class="page-box ac1">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!--    中部-->
    <div class="center-box">
      <!--banner-->
      <div class="banner-box">
        <div class="banner">
          <el-carousel trigger="click" class="height">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <div class="banner-img" @click="onClickBanner(item, index)">
                <img v-if="item.bgImage && item.bgImage.url != undefined" :src="item.bgImage.url" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!--新闻资讯 质控公告-->
      <div class="course-box">
        <div class="left">
          <div class="title-top">
            <div class="title-left">
              <div class="title-h">新闻资讯</div>
              <div class="title-p">Popular science knowledge</div>
            </div>
            <div class="title-right" @click="onClickRoute('/Information')">MORE+</div>
          </div>
          <news v-if="nationList.length > 0" :newsList="nationList" />
          <empty class="empty-margin" v-if="nationList.length <= 0"></empty>
        </div>
        <div class="right">
          <div class="title-top">
            <div class="title-left">
              <div class="title-h">质控公告</div>
              <div class="title-p">announcement</div>
            </div>
            <div class="title-right" @click="onClickRoute('/Announcement')">MORE+</div>
          </div>
          <announcement v-if="nationList2.length > 0" :announcement="nationList2" />
          <empty class="empty-margin" v-if="nationList2.length <= 0"></empty>
        </div>
      </div>
      <!--快捷入口-->
      <div class="rapidEntrance-box">
        <div class="rapidEntrance-left">
          <div class="rapidEntrance-h">快捷入口</div>
          <div class="rapidEntrance-p">Quick access</div>
        </div>
        <div class="rapidEntrance-right">
          <div class="rapidEntrance-li" @click="onClickRoute('/Meeting')">
            <img src="@/assets/images/rapid1.png" />
            <div class="rapidEntrance-name">会议直播</div>
          </div>
          <div class="rapidEntrance-li" @click="onClickRoute('/Handbook')">
            <img src="@/assets/images/rapid2.png" />
            <div class="rapidEntrance-name">指南共识</div>
          </div>
          <div class="rapidEntrance-li" @click="onClickRoute('/PersonalCenter')">
            <img src="@/assets/images/rapid3.png" />
            <div class="rapidEntrance-name">学习进度管理</div>
          </div>
          <div class="rapidEntrance-li" @click="onClickRoute('/ForumCenter')">
            <img src="@/assets/images/rapid4.png" />
            <div class="rapidEntrance-name">“向错误学习”平台</div>
          </div>
          <div class="rapidEntrance-li" @click="onClickRoute('/PersonalCenter?activeIndex=5')">
            <img src="@/assets/images/rapid5.png" />
            <div class="rapidEntrance-name">资质认证</div>
          </div>
        </div>
      </div>
      <!--指南共识 质控网络-->
      <div class="announcement-box">
        <div class="left">
          <div class="title-top">
            <div class="title-left">
              <div class="title-h">指南共识</div>
              <div class="title-p">Guideline consensus</div>
            </div>
            <div class="title-right" @click="onClickRoute('/Handbook')">MORE+</div>
          </div>
          <guide v-if="guideList.length > 0" :guide="guideList" pageRoute="GUIDE_CONSENSUS" />
          <empty class="empty-margin" v-if="guideList.length <= 0"></empty>
        </div>
        <div class="right">
          <div class="title-top">
            <div class="title-left">
              <div class="title-h">质控网络</div>
              <div class="title-p">Quality Control Network</div>
            </div>
            <div class="title-right" @click="onClickRoute('/Network')">MORE+</div>
          </div>
          <network v-if="calssList.length > 0" :network="calssList" />
          <empty class="empty-margin" v-if="calssList.length <= 0"></empty>
        </div>
      </div>
      <!--质控课程-->
      <div class="classification-box">
        <div class="title-top">
          <div class="title-left">
            <div class="title-h">质控课程</div>
            <div class="title-p">Quality control course</div>
          </div>
          <div class="title-right" @click="onClickRoute('/course')">MORE+</div>
        </div>
        <CourseList v-if="courses.length > 0" :courses="courses" :watchedList="watchedList" />
        <empty class="empty-margin" v-if="courses.length <= 0"></empty>
      </div>
    </div>
    <!--    中部end-->
    <!--<floatingwindow />-->
    <!--    页脚-->
    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>

</template>

<script>
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import FooterBar from "../../components/base/footerBar";
import floatingwindow from "@/components/base/floatingwindow";
import CourseList from "@/components/course/index.vue";
import news from "@/components/news/index.vue";
import announcement from '@/components/announcement/index.vue'
import guide from "@/components/guide/index.vue";
import network from "@/components/network/index.vue";
import { getPageList, getBannerList, getInformationType, getQualityControl } from '@/api/home'
import empty from "@/components/empty/index";

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, floatingwindow, CourseList, news, announcement, guide, network, empty },
  data() {
    return {
      selectedIndex: 0,
      calssList: [], // 分级质控
      watchedList: [], // 示例已观看的课程 ID
      nationList: [], // 新闻资讯
      navItems: [], // 导航项
      activeIndex: 0, // 默认激活第一个项
      navItems2: [{
        name: '省级质控中心',
        value: 'PROVINCE'
      }, {
        name: '地市级质控中心',
        value: 'CITY'
      }], // 导航项
      activeIndex2: 'PROVINCE', // 默认激活第一个项
      bannerList: [], // 轮播图
      nationList2: [], // 质控公告
      courses: [], // 质控课程
      guideList: [], // 指南共识
      appPage: {
        NEWS: 'NewsDetails',
        COURSE: 'CourseDetails',
        NOTICE: 'QualityControlDetails',
        SCIENCE: 'NewsDetailsTwo',
        SENTINEL_HOSPITAL: 'Recruitment',
        LIAISON_RECRUITMENT: 'Recruitment2',
        ADVERSE_EVENT: 'Recruitment3',
      },
      userInfo: {}
    }
  },
  methods: {
    islogin() {
      let token = localStorage.getItem("x-token")
      if (token == null) {
        this.$router.push({ path: `/codeLogin` });
        return false
      }
      return true
    },
    onClickBanner(item, index) {
      if (!this.islogin()) {
        return;
      }
      if (item.target === "APP_PAGE") {
        if (item.targetProps.appPage == "LIAISON_RECRUITMENT" || item.targetProps.appPage == "SENTINEL_HOSPITAL" || item.targetProps.appPage == "ADVERSE_EVENT") {
          this.$router.push({ path: `/${this.appPage[item.targetProps.appPage]}` });
        } else {
          this.$router.push({ path: `/${this.appPage[item.targetProps.appPage]}/${item.targetProps.appParams.id}` });
        }
      } else if (item.target === "H5") {
        window.open(item.targetProps.h5Url, '_blank');
      }
    },
    onClickRoute(path) {
      if (!this.islogin()) {
        return
      }
      if (path === "/ForumCenter" && this.userInfo.doctor.authentication != 'A1') {
        // this.$message({
        //   showClose: true,
        //   message: '请先上传执业证和身份证信息，后台认证审核通过后的您才能查看浏览该板块',
        //   type: 'warning'
        // });
        this.$confirm('请先上传执业证和身份证信息，后台认证审核通过后的您才能查看浏览该板块', '请先完善信息', {
          confirmButtonText: '前往',
        }).then(({ value }) => {
          this.$router.push({ path: `/PersonalCenter?activeIndex=5` });
        });
        return
      }
      this.$router.push(path)
    },
    setActive(index) {
      this.activeIndex = index; // 设置当前激活的项
      this.getPageList({
        number: 1,
        limit: 4,
        checkStatus: 'HAVE_RELEASED',
        categories: 'COURSE',
        type: this.activeIndex
      })
    },
    setActive2(index) {
      this.activeIndex2 = index; // 设置当前激活的项
      this.getQualityControl()
    },
    gotoAbout() {
      this.$router.push('/about')
    },
    // 轮播图
    getBannerList() {
      getBannerList({
        location: 'B0',
        client: 'PC',
      }).then(res => {
        this.bannerList = res.data
      })
    },
    // 分页查询新闻资讯、质控课程、质控公告、指南共识
    async getPageList(value) {
      await getPageList(value).then(res => {
        if (value.categories == 'NEWS') {
          this.nationList = res.data
        } else if (value.categories == 'COURSE') {
          this.courses = res.data
        } else if (value.categories == 'NOTICE') {
          this.nationList2 = res.data
        } else if (value.categories == 'GUIDE_CONSENSUS') {
          this.guideList = res.data
        }
      })
    },
    // 列表查询资讯类型
    async getInformationType() {
      await getInformationType({
        categories: 'COURSE',
      }).then(res => {
        this.navItems = res.data
        this.activeIndex = res.data.length > 0 ? res.data[0].id : ''
      })
    },
    // 分页查询分级质控
    getQualityControl() {
      getQualityControl({
        number: 1,
        limit: 4,
        level: 'PROVINCE',
      }).then(res => {
        this.calssList = res.data
      })
    },
    // 初始化
    async Initialization() {
      this.getBannerList()
      this.getPageList({
        number: 1,
        limit: 6,
        checkStatus: 'HAVE_RELEASED',
        categories: 'NEWS',
      })
      await this.getInformationType()
      await this.getPageList({
        number: 1,
        limit: 8,
        checkStatus: 'HAVE_RELEASED',
        categories: 'COURSE',
        // type: this.activeIndex
      })
      await this.getPageList({
        number: 1,
        limit: 4,
        checkStatus: 'HAVE_RELEASED',
        categories: 'NOTICE',
      })
      await this.getPageList({
        number: 1,
        limit: 9,
        checkStatus: 'HAVE_RELEASED',
        categories: 'GUIDE_CONSENSUS',
      })
      this.getQualityControl()
    },
    gotoDetails(id) {
      this.$router.push({ path: `/QualityControlDetails/${id}` }); // 动态路由传递课程 id
    },
    gotonewsDetails(id) {
      this.$router.push({ path: `/NewsDetails/${id}` }); // 动态路由传递课程 id
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")) : {}
    var wow = new this.$wow.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    this.Initialization()
  }
}
</script>
<style lang="less">
.ac1>.box {
  background: none !important;
}
</style>
<style lang="less" scoped>
@color: #9C1D22;

.page-box {
  background: url("~@/assets/images/index-bg.png") no-repeat #fff;
  background-size: 100% 674px;
}

.title-top {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title-right {
    color: rgba(140, 26, 17, 1);
    font-size: 16px;
    line-height: 16px;
    font-weight: bold;
    cursor: pointer;
  }

  .title-left {
    text-align: left;

    .title-h {
      color: rgba(131, 17, 22, 1);
      font-size: 26px;
      line-height: 26px;
      font-weight: bold;
    }

    .title-p {
      color: rgba(163, 163, 163, 1);
      font-size: 18px;
      line-height: 18px;
      margin-top: 6px;
    }
  }
}

.rapidEntrance-box {
  background: #f5f5f5;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  height: 149px;

  .rapidEntrance-left {
    width: 261px;
    background: url("~@/assets/images/rapid-left.png") no-repeat;
    background-size: 100% 100%;
    height: 100%;
    color: #fff;
    padding-top: 48px;
    box-sizing: border-box;
    text-align: left;
    padding-left: 47px;

    .rapidEntrance-h {
      font-size: 30px;
      line-height: 30px;
      font-weight: bold;
      margin-bottom: 6px;
    }

    .rapidEntrance-p {
      font-size: 18px;
      line-height: 18px;
    }
  }

  .rapidEntrance-right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 836px;
    margin-left: 105px;

    .rapidEntrance-li:hover {
      .rapidEntrance-name {
        color: rgba(156, 29, 34, 1);
      }
    }

    .rapidEntrance-li {
      cursor: pointer;

      img {
        width: 68px;
        height: 68px;
      }

      .rapidEntrance-name {
        color: rgba(38, 38, 38, 1);
        font-size: 18px;
        line-height: 18px;
        margin-top: 12px;
      }
    }
  }
}

.banner-box {
  display: flex;
  background: #fff;
  margin-bottom: 58px;

  .banner {
    flex: 1;

    .banner-img {
      position: relative;
      width: 100%;
      height: 420px;

      .banner-text {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 79px;
        width: 100%;
        background: linear-gradient(90deg, #9C1D22 0%, rgba(156, 29, 34, 0.1) 100%);
        color: #fff;
        font-size: 24px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .message-box {
    width: calc(100% - 878px);
    padding: 16px 16px 16px 0;
    box-sizing: border-box;
  }
}

.height {
  height: 420px;

  /deep/.el-carousel__container {
    height: 100%;
  }
}

.center-box {
  width: 1300px;
  margin: 34px auto;

  .nation-ul.active {
    margin-top: 0;

    .nation-li:hover {
      .nation-left {
        color: #9C1D22;
      }
    }

    .nation-li {
      display: block;
      text-align: left;
      margin-top: 14.5px;

      .nation-left:before {
        top: 7.5px;
      }

      .nation-right {
        padding-left: 18px;
      }

      .nation-left {
        white-space: inherit;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 22px;
        width: 100%;
        box-sizing: border-box;
      }
    }
  }

  .nation-ul {
    margin-top: 28px;

    .nation-li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 28px;
      margin-top: 22px;
      cursor: pointer;

      .nation-left {
        color: #222222;
        font-size: 16px;
        width: 85%;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        padding-left: 18px;
        position: relative;
      }

      .nation-left:before {
        content: '';
        position: absolute;
        background: @color;
        width: 5.5px;
        height: 5.5px;
        transform: rotate(45deg);
        margin-right: 10px;
        left: 1px;
        top: 50% - 2.75px;
      }

      .nation-right {
        color: #626365;
        font-size: 14px;
      }
    }
  }

  .nation-top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 300px;
      height: 220px;
      margin-right: 20px;
    }

    .nation-text {
      width: calc(100% - 320px);
      text-align: left;

      .nation-h {
        color: rgba(34, 34, 34, 1);
        font-size: 18px;
        line-height: 26px;
        font-weight: bold;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .nation-p {
        color: #626365;
        font-size: 16px;
        line-height: 26px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .nation-time {
        color: #626365;
        font-size: 16px;
        line-height: 16px;
        margin-top: 8px;
        margin-bottom: 12px;
      }

      .nation-bt {
        display: flex;
        align-items: center;
        color: @color;
        font-size: 14px;
        cursor: pointer;
        margin-top: 20px;

        img {
          display: block;
          width: 14px;
          height: 13.5px;
          margin-left: 10px;
        }
      }
    }
  }
}

.nation-box {
  background: #fff;
  padding: 20px;
}

.announcement-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;

  .left {
    width: 636px;
    border-top: 4px solid rgba(164, 18, 24, 1);
    padding-top: 20px;
  }

  .right {
    width: 636px;
    border-top: 4px solid rgba(164, 18, 24, 1);
    padding-top: 20px;
  }
}

.course-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 58px;

  .left {
    width: 900px;
    margin-right: 28px;
  }

  .right {
    width: calc(100% - 928px);
  }
}

.classification-ul {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .classification-li {
    width: 307px;
    height: 393px;
    padding: 24px;
    box-sizing: border-box;
    background: #fff;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .classification-img {
      height: 90px;
      width: 90px;

      img {
        height: 90px;
        vertical-align: bottom;
      }
    }

    .classification-h {
      color: #333333;
      font-size: 20px;
      font-weight: bold;
      line-height: 20px;
      margin: 14px 0;
    }

    .classification-p {
      color: #626365;
      font-size: 16px;
      line-height: 28px;
      width: 100%;
      /* 设置容器宽度 */
      line-height: 28px;
      /* 行高，确保文本正常显示 */
      overflow: hidden;
      /* 超出部分隐藏 */
      display: -webkit-box;
      /* 使用 Flexbox 布局 */
      -webkit-box-orient: vertical;
      /* 设置盒子为垂直方向排列 */
      -webkit-line-clamp: 3;
      /* 限制显示的行数 */
      text-overflow: ellipsis;
      /* 超出部分用省略号表示 */
    }

    .classification-bt {
      border: 1px solid #D1D1D1;
      width: 164px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: absolute;
      bottom: 24px;
      left: calc(50% - 82px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue